
















import CommonBase from "./CommonBase";
import {Component, Prop} from "vue-property-decorator";
import {Route} from "vue-router";

@Component
export default class InfoDialog extends CommonBase {
    @Prop({default: false})
    value!: boolean;
    @Prop({default: "Info"})
    title!: string;
    @Prop({default: "info"})
    category!: string;
    @Prop({default: null})
    moreTo!: Route | null;

    get model() {
        return this.value;
    }
    set model(v: boolean) {
        this.$emit("input", v);
    }

    close() {
        this.model = false;
    }
}
